import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-portfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.styl']
})
export class PortfolioComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

  onModalClick(element) {
    if (element.classList.contains('rm-modal')) {
      element.classList.remove('rm-modal');
    } else {
      element.classList.add('rm-modal');
    }
  }

}



// WEBPACK FOOTER //
// /Users/davcocom/Documents/Documents - David’s MacBook Pro/resume/resume-onepage/src/app/portfolio/portfolio.component.ts